import { CIMSModule } from '../../CIMSModule'
import { CIMSPageItem } from '../CIMSPageItem'

export const DeveloperSnapshots = new CIMSPageItem({
  id: 'b0f76e0d-9069-4bd5-a07b-9c68f425b146',
  module: CIMSModule.Developer,
  name: 'Snapshots',
  pathname: 'snapshots',
})

export const UserSync = new CIMSPageItem({
  id: '53140d6a-9fd7-400b-ab4c-f059fd2c461c',
  module: CIMSModule.Developer,
  name: 'User Sync',
  pathname: 'user-sync',
})

export const Developers = new CIMSPageItem({
  id: 'ba9e3197-f2b4-40f7-a579-9f9e6407a93f',
  module: CIMSModule.Developer,
  name: 'Developers',
  pathname: 'developers',
})

export type DeveloperPageItem =
  | typeof DeveloperSnapshots
  | typeof UserSync
  | typeof Developers
